module.exports = __webpack_public_path__ + "media/images/emblems/Seewis_wappen-2937008935a74ae5fa9e2e87fbb93cb2.svg";